
import React from 'react';
import ScrollReveal from './ScrollReveal';

const Section = ({ id, title, children, className }) => {
    return (
        <section id={id} className={`section ${className || ''}`}>
            <div className="container">
                <ScrollReveal>
                    {title && <h2 style={{ marginBottom: '3rem', textAlign: 'center' }}>{title}</h2>}
                    {children}
                </ScrollReveal>
            </div>
        </section>
    );
};

export default Section;
